import React, {useEffect, useState} from 'react'
import { DescSortIcon, SortIcon, AscSortIcon } from '../../../../modules/CustomIcons'
import { Button } from 'antd'
import './index.scss'
import moment from 'moment'

function SortableColumn(props: any) {
  const [ascDesc, setAsc] = useState(props.ascDesc !== undefined && props.ascDesc !== null ? props.ascDesc : '')

  if (props?.isFiltered === false) {
    props?.setDataOriginal && props?.setDataOriginal(props.data)
  }

  useEffect(() => {
    setAsc(props.ascDesc !== undefined && props.ascDesc !== null ? props.ascDesc : '')
  }, [props.ascDesc])
  const handleSortData = (direction: string) => {

    const newData = [...props.data]


    let sortedTableList;
    if (direction === "desc") {
      console.log('desc')
      if (props.type === "date") {
        if (props?.dataIndex) {
          const subNewData = [...props.data[props.dataIndex]["data"]]
          let sortedTableListData;
          if (props?.paramater_second) {
            if (props?.hasTime) {
              sortedTableListData = subNewData.sort((a, b) => moment(b[props.parameter][props?.paramater_second], "DD.MM.YYYY HH:mm").unix() - moment(a[props.parameter][props?.paramater_second], "DD.MM.YYYY HH:mm").unix())
            } else {
              sortedTableListData = subNewData.sort((a, b) => moment(b[props.parameter][props?.paramater_second], "DD.MM.YYYY").unix() - moment(a[props.parameter][props?.paramater_second], "DD.MM.YYYY").unix())
            }
          } else {
            if (props?.hasTime) {
              sortedTableListData = subNewData.sort((a, b) => moment(b[props.parameter], "DD.MM.YYYY HH:mm").unix() - moment(a[props.parameter], "DD.MM.YYYY HH:mm").unix())
            } else {
              console.log(subNewData.sort((a, b) => moment(b[props.parameter], "DD.MM.YYYY").unix() - moment(a[props.parameter], "DD.MM.YYYY").unix() ))
              sortedTableListData = subNewData.sort((a, b) => moment(b[props.parameter], "DD.MM.YYYY").unix() - moment(a[props.parameter], "DD.MM.YYYY").unix())
            }
          }
          sortedTableList = [...newData]
          sortedTableList[props.dataIndex]["data"] = sortedTableListData
        } else {
          if (props?.paramater_second) {
            if (props?.hasTime) {
              sortedTableList = newData.sort((a, b) => moment(b[props.parameter][props?.paramater_second], "DD.MM.YYYY HH:mm").unix() - moment(a[props.parameter][props?.paramater_second], "DD.MM.YYYY HH:mm").unix())
            } else {
              sortedTableList = newData.sort((a, b) => moment(b[props.parameter][props?.paramater_second], "DD.MM.YYYY").unix() - moment(a[props.parameter][props?.paramater_second], "DD.MM.YYYY").unix())
            }
          } else {
            if (props?.hasTime) {
              sortedTableList = newData.sort((a, b) => moment(b[props.parameter], "DD.MM.YYYY HH:mm").unix() - moment(a[props.parameter], "DD.MM.YYYY HH:mm").unix())
            } else {
              if(props?.documentsDate){
                if(props.pagetransfer){
                sortedTableList = newData.sort((a, b) => moment(b[props.parameter], "MM.DD.YYYY").unix() - moment(a[props.parameter], "MM.DD.YYYY").unix())
                }
                sortedTableList = newData.sort((a, b) => moment(b[props.parameter], "YYYY-MM-DD").unix() - moment(a[props.parameter], "YYYY-MM-DD").unix())

                console.log(sortedTableList)
              }else{
                sortedTableList = newData.sort((a, b) => moment(b[props.parameter], "DD.MM.YYYY").unix() - moment(a[props.parameter], "DD.MM.YYYY").unix())

              }
              
            }
          }
        }

      }

      if (props.type === "index") {
        sortedTableList = newData.sort((a, b) => {
          if (isNaN(Number((b[props.parameter])))) {
            return 1 - isNaN(Number((a[props.parameter])));
          }
          else if (isNaN(Number((a[props.parameter])))) {
            return isNaN(Number((b[props.parameter]))) - 1;
          }
          else {
            return Number((b[props.parameter])) - Number((a[props.parameter]));
          }
        })
      }


      if (props.type === "string") {
        sortedTableList = newData.sort((a, b) => b[props.parameter].localeCompare(a[props.parameter]))
      }

      if (props.type === "number") {
        try {
          if (props?.paramater_second) {
            sortedTableList = newData?.sort((a, b) => {
              if (isNaN(Number((b[props.parameter][props?.paramater_second])))) {
                return 1 - isNaN(Number((a[props.parameter][props?.paramater_second])));
              } else if (isNaN(Number((a[props.parameter][props?.paramater_second])))) {
                return isNaN(Number((b[props.parameter][props?.paramater_second]))) - 1;
              } else {
                return Number((b[props.parameter][props?.paramater_second])) - Number((a[props.parameter][props?.paramater_second]));
              }
            })

          } else {

            sortedTableList = newData?.sort((a, b) => {

              if (isNaN(Number((b[props.parameter]).toString().replace(/ +/g, "")))) {
                return 1 - isNaN(Number((a[props.parameter]).toString().replace(/ +/g, "")));
              } else if (isNaN(Number((a[props.parameter]).toString().replace(/ +/g, "")))) {
                return isNaN(Number((b[props.parameter]).toString().replace(/ +/g, ""))) - 1;
              } else {
                return Number((b[props.parameter]).toString().replace(/ +/g, "")) - Number((a[props.parameter]).toString().replace(/ +/g, ""));
              }
            })

          }
        } catch (e) {

        }
      }

      props.setData(sortedTableList)
      if (props?.setIsFiltered) {
        props.setIsFiltered(true)
      }
    }
    else if (direction === "asc") {
      if (props.type === "date") {
        if (props?.dataIndex) {
          const subNewData = [...props.data[props.dataIndex]["data"]]
          let sortedTableListData;
          if (props?.paramater_second) {
            if (props?.hasTime) {
              sortedTableListData = subNewData.sort((a, b) => moment(a[props.parameter][props?.paramater_second], "DD.MM.YYYY HH:mm").unix() - moment(b[props.parameter][props?.paramater_second], "DD.MM.YYYY HH:mm").unix())
            } else {
              sortedTableListData = subNewData.sort((a, b) => moment(a[props.parameter][props?.paramater_second], "DD.MM.YYYY").unix() - moment(b[props.parameter][props?.paramater_second], "DD.MM.YYYY").unix())
            }
          } else {
            if (props?.hasTime) {
              sortedTableListData = subNewData.sort((a, b) => moment(a[props.parameter], "DD.MM.YYYY HH:mm").unix() - moment(b[props.parameter], "DD.MM.YYYY HH:mm").unix())
            } else {
              if(props?.documentsDate){
                if(props.pagetransfer){
                sortedTableList = newData.sort((a, b) => moment(a[props.parameter], "MM.DD.YYYY").unix() - moment(b[props.parameter], "MM.DD.YYYY").unix())
                }
                sortedTableList = newData.sort((a, b) => moment(a[props.parameter], "YYYY-MM-DD").unix() - moment(b[props.parameter], "YYYY-MM-DD").unix())

                console.log(sortedTableList)
              }else{
                sortedTableListData = subNewData.sort((a, b) => moment(a[props.parameter], "DD.MM.YYYY").unix() - moment(b[props.parameter], "DD.MM.YYYY").unix())


              }
            }

          }
          sortedTableList = [...newData]
          sortedTableList[props.dataIndex]["data"] = sortedTableListData
        } else {
          if (props?.paramater_second) {
            if (props?.hasTime) {
              sortedTableList = newData.sort((a, b) => moment(a[props.parameter][props?.paramater_second], "DD.MM.YYYY HH:mm").unix() - moment(b[props.parameter][props?.paramater_second], "DD.MM.YYYY HH:mm").unix())
            } else {
              sortedTableList = newData.sort((a, b) => moment(a[props.parameter][props?.paramater_second], "DD.MM.YYYY").unix() - moment(b[props.parameter][props?.paramater_second], "DD.MM.YYYY").unix())
            }

          } else {
            if (props?.hasTime) {
              sortedTableList = newData.sort((a, b) => moment(a[props.parameter], "DD.MM.YYYY HH:mm").unix() - moment(b[props.parameter], "DD.MM.YYYY HH:mm").unix())
            } else {
              console.log(newData.sort((a, b) => moment(b[props.parameter], "DD.MM.YYYY").unix() - moment(a[props.parameter], "DD.MM.YYYY").unix() ))

              sortedTableList = newData.sort((a, b) => moment(a[props.parameter], "DD.MM.YYYY").unix() - moment(b[props.parameter], "DD.MM.YYYY").unix())
            }

          }
        }
      }

      if (props.type === "index") {
        sortedTableList = newData.sort((a, b) => {
          if (isNaN(Number(a[props.parameter]))) {
            return 1 - isNaN(Number(b[props.parameter]));
          }
          else if (isNaN(Number(b[props.parameter]))) {
            return isNaN(Number(a[props.parameter])) - 1;
          }
          else {
            return Number(a[props.parameter]) - Number(b[props.parameter]);
          }
        })
      }


      if (props.type === "string") {
        sortedTableList = newData.sort((a, b) => a[props.parameter].localeCompare(b[props.parameter]))
      }

      if (props.type === "number") {
        if (props?.paramater_second) {
          sortedTableList = newData.sort((a, b) => {
            if (isNaN(Number(a[props.parameter][props?.paramater_second]))) {
              return 1 - isNaN(Number(b[props.parameter][props?.paramater_second]));
            }
            else if (isNaN(Number(b[props.parameter][props?.paramater_second]))) {
              return isNaN(Number(a[props.parameter][props?.paramater_second])) - 1;
            }
            else {
              return Number(a[props.parameter][props?.paramater_second]) - Number(b[props.parameter][props?.paramater_second]);
            }
          })
        } else {
          sortedTableList = newData.sort((a, b) => {

            if (isNaN(Number(a[props.parameter]))) {
              return 1 - isNaN(Number(b[props.parameter]));
            }
            else if (isNaN(Number(b[props.parameter]))) {
              return isNaN(Number(a[props.parameter])) - 1;
            }
            else {
              return Number(a[props.parameter]) - Number(b[props.parameter]);
            }
          })
        }
      }

      props.setData(sortedTableList)
      if (props?.setIsFiltered) {
        props.setIsFiltered(true)
      }
    }
    else {

      props.setData(props.dataOriginal)
    }
  }

  const onchange = (value: string) => {
    setAsc(value);
    handleSortData(value);
    if (props.onchangeSort) {
      props.onchangeSort(props.parameter, value);
    }
  }
  let switchrender = () => {
    switch (ascDesc) {
      case 'asc': return <Button className='sorter-btn sorter-btn-asd active' icon={<AscSortIcon />} onClick={() => { onchange('desc') }} />
      case 'desc': return <Button className='sorter-btn sorter-btn-asd  active' icon={<DescSortIcon />} onClick={() => { onchange('')  }} />
      default: return <Button style={{ bottom: 3, height: '22px' }} className='sorter-btn' icon={<SortIcon />} onClick={() => { onchange('asc')  }} />
    }
  }
  return (
    <>
      {switchrender()}
    </>
  )
}
export default SortableColumn
